import _ from 'ckLodash';
import ckHelper from 'utils/utils';
import elementUtils from 'utils/elementUtils';
import rangeUtils from 'utils/rangeUtils';
import selectionUtils from 'utils/selectionUtils';

var LINK_STYLE = new CKEDITOR.style({
    element: 'a',
    type: CKEDITOR.STYLE_INLINE,
    alwaysRemoveElement: 1
});

/**
 * @constructor
 */
function LinkCommand() {
}

function UnlinkCommand() {
}

LinkCommand.prototype = {
    canUndo: true,
    editorFocus: CKEDITOR.env.ie || CKEDITOR.env.webkit,
    contextSensitive: true,
    /**
     * @param editor
     * @param value {Object} with property 'dataQuery' which is the the reference to the data in the viewer
     */
    exec: function (editor, value) {
        editor.undoManager.save();
        editor.undoManager.lock(true);

        // this must happen before linking because it fixes the selection on IE:  https://jira.wixpress.com/browse/SE-14056
        editor.execCommand('wixUnlink');
        execApplyLink(editor, value);

        this.refresh(editor);

        moveCursorToAfterLink(editor);
        editor.fire('change');
        editor.undoManager.unlock();
    },

    refresh: function (editor) {
        var linkElem = getFirstSelectedLink(editor);
        if (linkElem) {
            this.setState(linkElem.getAttribute('dataQuery'));
        } else {
            this.setState(null);
        }
    },

    canPerformCmd: function (editor) {
        //when calling this function in early stages of the editor, isMultipleBlockSelection failing, and causing problems.
        try {
            if (selectionUtils.isMultipleBlockSelection(editor)) {
                return false;
            }
        } catch (e) {
            return false;
        }

        //todo - move to selection utils with tests
        var selectedHtml = selectionUtils.getSelectedHtml(editor);
        if (!selectedHtml || selectedHtml.$ === null) {
            return false;
        }

        if (!selectionUtils.isSelectedTextEmpty(editor)) {
            return true;
        }

        //if cursor is inside an already existing link then cmd can be applied
        return !!editor.elementPath().contains('a');
    }
};

UnlinkCommand.prototype = {
    exec: function (editor) {
        editor.getCommand('wixSelectLinks').exec();

        editor.undoManager.lock(true);
        editor.execCommand('underline');
        // making sure we removed the underline
        if (editor.getCommand('underline').state === CKEDITOR.TRISTATE_ON) {
            editor.execCommand('underline');
        }
        editor.undoManager.unlock();

        editor.removeStyle(LINK_STYLE);
    },

    refresh: function (editor, path) {
        // Despite our initial hope, document.queryCommandEnabled() does not work
        // g this in Firefox. So we must detect the state by element paths.

        var element = path.lastElement && path.lastElement.getAscendant('a', true);

        if (element && element.getName() === 'a' && element.getChildCount()) {
            this.setState(CKEDITOR.TRISTATE_OFF);
        } else {
            this.setState(CKEDITOR.TRISTATE_DISABLED);
        }
    }
};

function applyLinkToSingleParentSelection(attributes, range) {
    var style = new CKEDITOR.style({element: 'a', attributes: attributes});
    style.type = CKEDITOR.STYLE_INLINE; // need to override... dunno why.
    style.applyToRange(range);
    range.select();
}

function applyLinkToMultiParentSelection(attributes, editor) {
    var elem = new CKEDITOR.dom.element('a');
    elem.setAttributes(attributes);
    elem.setHtml(selectionUtils.getSelectedHtml(editor).getHtml());
    editor.insertElement(elem);
    editor.getSelection().selectElement(elem);
}

function applyLinkToSelection(selection, attributes, editor) {
    var range = selection.getRanges(1)[0];
    if (range.startContainer.getUniqueId() === range.endContainer.getUniqueId()) {
        applyLinkToSingleParentSelection(attributes, range);
    } else {
        applyLinkToMultiParentSelection(attributes, editor);
    }
}

function execApplyLink(editor, attributes) {
    applyLinkToSelection(editor.getSelection(), attributes, editor);

    if (editor.getCommand('underline').state === CKEDITOR.TRISTATE_OFF) {
        editor.execCommand('underline');
    }
}

function getFirstSelectedLink(editor) {
    var selection = editor.getSelection();
    var selectedElement = selection.getSelectedElement();
    if (selectedElement && selectedElement.is('a')) {
        return selectedElement;
    }

    var range = selectionUtils.getSelectedRange(editor);
    if (range) {
        return (
            elementUtils.getElementFromPath(range.startPath(), 'a') ||
            rangeUtils.getElementFromRange(range, 'a', true) ||
            null
        );
    }
    return null;
}

function moveCursorToAfterLink(editor) {
    var link = getFirstSelectedLink(editor); //there is only one link in the selection at this point
    removeTrailingBrFromLink(link);
    var linkWrapper = getUppermostInlineWrapper(link);

    setCursorAfterElement(editor, linkWrapper);
}

function getUppermostInlineWrapper(element) {
    var parentElement = element.getParent();

    while (parentElement.getChildCount() === 1 && !ckHelper.isBlockElement(parentElement.getName())) {
        element = parentElement;
        parentElement = parentElement.getParent();
    }

    return element;
}

function removeTrailingBrFromLink(linkElem) {
    if (_.result(linkElem.getLast(), 'getName') === 'br') {
        linkElem.getLast().remove();
    }
}

function setCursorAfterElement(editor, element) {
    var range = editor.createRange();
    range.setStartAfter(element);
    range.collapse(true);
    range.select();
}

export default {
    init: function (editor) {
        editor.addCommand('wixLink', new LinkCommand());
        editor.addCommand('wixUnlink', new UnlinkCommand());
    }
};
